export const ORGANIZATION_TABLE_PAGE_SIZE = 5;
